export default "__VITE_ASSET__D8uXFg5A__"